'use client';

import { useEffect } from 'react';
import { useDraftSaveOrchestrator } from '../hooks/useDraftSaveOrchestrator';
import { useScheduler } from '../SchedulerContext';

/**
 * Draft Auto-Saver Component
 * 
 * This component orchestrates automatic draft saving throughout the scheduler flow.
 * It renders nothing but uses the useDraftSaveOrchestrator hook to:
 * - Save drafts on step transitions
 * - Save drafts on critical field changes (debounced)
 * 
 * Must be placed inside SchedulerProvider to have access to scheduler context.
 * Must have access to StepNavigationProvider to watch step changes.
 * 
 * This centralizes all draft save logic so individual step components
 * don't need to know about or handle draft saving.
 */
export default function DraftAutoSaver() {
  const { cancelDebounce } = useDraftSaveOrchestrator();
  const { setCancelDebounceRef } = useScheduler();
  
  // Expose cancelDebounce to the context so other components can use it
  useEffect(() => {
    setCancelDebounceRef(cancelDebounce);
    return () => {
      setCancelDebounceRef(null);
    };
  }, [cancelDebounce, setCancelDebounceRef]);
  
  // This component renders nothing - it only handles side effects
  return null;
}

